import { render, staticRenderFns } from "./ProjectViewForm.vue?vue&type=template&id=874f18e2&"
import script from "./ProjectViewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports